import { PlainLink } from '@knorr-bremse-portals/ngx-components';
import { SectionAttributes, InnerSection } from './section';

interface CommonLinkAttributes extends SectionAttributes {
  url: string;
  target: '_self' | '_blank';
  label?: string; // st_link_internal_no_label & st_link_external_no_label
  icon?: string;
}

type InternalLinkAttributes = CommonLinkAttributes

interface ExternalLinkAttributes extends CommonLinkAttributes {
  external: true;
}

type LinkEditorIds = [
  'url',
  'target',
  'label',
];

type ExternalLinkSection = InnerSection<ExternalLinkAttributes, LinkEditorIds, 'external-link'>;
type InternalLinkSection = InnerSection<InternalLinkAttributes, LinkEditorIds, 'internal-link'>;

export type LinkSection = ExternalLinkSection | InternalLinkSection;

export function toPlainLink(linkSection: LinkSection): PlainLink {
  return {
    href: linkSection.attributes.url,
    target: linkSection.attributes.target || ((linkSection.attributes as ExternalLinkAttributes).external ? '_blank' : undefined),
  }
}
